var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{attrs:{"current-page":_vm.pageNum,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pageSize,"layout":"total, prev, pager, next, sizes, jumper","total":_vm.total,"hide-on-single-page":""},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }